/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/**
 * Contains the selectors that select state from the 'UAUserAccount' store object.
 * @namespace UAUserAccountSelectors
 */
export default class selectors {
  /**
   * @private
   */
  static moduleIdentifier = 'UAUAUserAccount';

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof UAUserAccountSelectors
   */
  static postAcesSecretQuestionPasswordReset = state =>
    state[selectors.moduleIdentifier].postAcesSecretQuestionPasswordReset.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof UAUserAccountSelectors
   */
  static isFetchingPostAcesSecretQuestionPasswordReset = state =>
    state[selectors.moduleIdentifier].isFetchingPostAcesSecretQuestionPasswordReset.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof UAUserAccountSelectors
   */
  static postAcesSecretQuestionPasswordResetError = state =>
    state[selectors.moduleIdentifier].postAcesSecretQuestionPasswordResetError.payload;
}
